var pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var self = locals || {};pug_mixins["nav-scroll"] = pug_interp = function(href, name){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cli class=\"site-link\"\u003E\u003Ca" + (" class=\"scrollable\""+pug.attr("id", "mid_" + name, true, true)+pug.attr("href", href, true, true)+" role=\"presentation\""+pug.attr("data-route-link", true, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
};
pug_mixins["hamburger"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"hamburger\"\u003E\u003Cdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
































pug_mixins["job-arrow"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg class=\"job-arrow\" version=\"1.1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 143.2 77.6\" style=\"enable-background:new 0 0 143.2 77.6;\" xml:space=\"preserve\"\u003E\u003Cpath d=\"M133.1,5.1L133.1,5.1c-1.1-1-2.5-1.6-4-1.6c-1.5,0-2.9,0.6-4,1.7L71.7,60.2L18.2,5.1c-2.2-2.2-5.7-2.3-8-0.1\t\tc-1.1,1-1.7,2.5-1.8,4c0,1.5,0.5,3,1.6,4.1l57.6,59.3c1.1,1.1,2.5,1.7,4.1,1.7c1.5,0,3-0.6,4.1-1.7L133.2,13\t\tC135.4,10.8,135.3,7.2,133.1,5.1z\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fsvg\u003E";
};




















pug_mixins["icon"] = pug_interp = function(name){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg\u003E\u003Cuse" + (pug.attr("xlink:href", `${require(`icons/${name}.svg`)}#Layer_1`, true, true)) + "\u003E\u003C\u002Fuse\u003E\u003C\u002Fsvg\u003E";
};
pug_mixins["twitter"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_mixins["icon"]('twitter');
};




































































pug_html = pug_html + "\u003Cdiv class=\"container-fluid\"\u003E\u003Cdiv id=\"header\"\u003E";
var routes = require('templates/data/routes.json')
pug_html = pug_html + "\u003Cheader class=\"desktop\" id=\"navigation\" role=\"navigation\"\u003E\u003Cdiv class=\"logo\"\u003E\u003Ca class=\"scrollable\" href=\"\u002F\" data-route-link\u003E\u003Cimg" + (pug.attr("src", require("img/logo.svg"), true, true)) + "\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main-nav-container\"\u003E\u003Cul class=\"nav nav-tabs main-nav\"\u003E";
// iterate routes.internal
;(function(){
  var $$obj = routes.internal;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var route = $$obj[pug_index0];
pug_mixins["nav-scroll"](route.path, route.title);
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var route = $$obj[pug_index0];
pug_mixins["nav-scroll"](route.path, route.title);
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cli class=\"nav-break\"\u003E\u003C\u002Fli\u003E";
// iterate routes.external
;(function(){
  var $$obj = routes.external;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var route = $$obj[pug_index1];
pug_mixins["nav-scroll"](route.path, route.title);
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var route = $$obj[pug_index1];
pug_mixins["nav-scroll"](route.path, route.title);
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cli\u003E\u003Ca class=\"blog-indicator\" href=\"https:\u002F\u002Ftouk.pl\u002Fblog\" target=\"_blank\"\u003EBlog\u003Cspan id=\"newPostsCount\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003Cheader class=\"mobileheader\"\u003E\u003Cdiv class=\"col-xs-2 logo\"\u003E\u003Ca class=\"scrollable\" href=\"\u002F\" data-route-link\u003E\u003Cimg" + (pug.attr("src", require("img/logo-mobile.png"), true, true)+" alt=\"TouK\"") + "\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E";
pug_mixins["hamburger"]();
pug_html = pug_html + "\u003Cdiv id=\"mobilenav\"\u003E\u003Cul class=\"main-nav\"\u003E";
// iterate routes.internal
;(function(){
  var $$obj = routes.internal;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var route = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (" class=\"navlink scrollable\""+pug.attr("href", route.path, true, true)+pug.attr("data-route-link", true, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = route.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var route = $$obj[pug_index2];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (" class=\"navlink scrollable\""+pug.attr("href", route.path, true, true)+pug.attr("data-route-link", true, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = route.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"mobilenav-divider\"\u003E\u003C\u002Fdiv\u003E";
// iterate routes.external
;(function(){
  var $$obj = routes.external;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var route = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (" class=\"navlink scrollable\""+pug.attr("href", route.path, true, true)+pug.attr("data-route-link", true, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = route.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var route = $$obj[pug_index3];
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (" class=\"navlink scrollable\""+pug.attr("href", route.path, true, true)+pug.attr("data-route-link", true, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = route.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cli\u003E\u003Ca class=\"navlink scrollable blog-indicator\" href=\"https:\u002F\u002Ftouk.pl\u002Fblog\" target=\"_blank\"\u003EBlog\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;